// extracted by mini-css-extract-plugin
export default {"check":"RTCheckbox-check--I04K","checked":"RTCheckbox-checked-_IXA9"};